import { initialMakePaymentRequest } from './make-payment-init.model';
import { initialDeliveryLocation, initialCollectionLocation } from './location-init.model';

export const initialAdditionalFlightData = {
  finalAirportCityName: null,
  finalAirportCode: null,
  finalAirportName: null,
  finalAirportCountryName: null
};

export const initialManualFlightData = {
  // arrivalCity: '',
  // airline: '',
  // airportName: '',
  // airportTerminal: '',
  // arrivalDateTime: '',
  // hasLandedNow: false
  // airportCityName: 'London',
  // airline: '',
  // airportName: '',
  // airportCode: '',
  // airportTerminal: '',
  // arrivalDateTime: '',
  // hasLandedNow: false
};

export const initialBooking = {
  bookingReference: '',
  bookingUser: null,
  hasMarketingEnrolment: false,
  HasAirFranceGVACustomsAgreement: false,
  dataSharingAllowed: false,
  smsMarketingReminder:false,
  bookingJourney: [],
  dataLinkSessionId: null,
  returnSessionId: null,
  timeSlotReservation: {
    timeSlotReservationId: '',
    reservationStartTime: '',
    reservationEndTime: '',
    timeSlotType: null
  },
  makePaymentRequest: initialMakePaymentRequest,
  refundRequest: null,
  bookingCompletion: {
    collectionLocationDetails: false,
    collectionDateTimeDetails: false,
    deliveryLocationDetail: false,
    deliveryDateTimeDetails: false,
    bookingComplete: false
  },
  hasCustomsAgreement: false,
  bookingzoneId: '',
  generateBookingReferenceRequest: null,
  hasEmiratesSkywardsAcknowledgment: false,
};

export const initialBookingJourney = {
  addOnProductType: [
    1
  ],
  journeyDirection: 1,
  flightData: {
    departureAirportCode: '',
    flightInfoId: '',
    requestFlightNumber: '',
    requestDepartureDate: '',
    airportCityName: '',
    flightLeg: 1,
    additionalFlightDataRequest: initialAdditionalFlightData
  },
  manualFlightData: initialManualFlightData,
  collectionLocation: initialCollectionLocation,
  collectionDateTimeUTC: '',
  deliveryDateTimeUTC: '',
  deliveryLocation: initialDeliveryLocation,
  note: {
    text: '',
    priority: 'Medium'
  },
  bookingContact: null,
  virtualBagCount: 0,
  virtualBagClassification: [
    {
      Type: "Bags",
      Count: 0
    },
    {
      Type: "ChildEquipment",
      Count: 0
    },
    {
      Type: "OversizeItem",
      Count: 0
    }
  ],
  hasOversizedBag: false,
  productTierId: null,
  timeSlotId: null,
  flightDetails: null,
  utmSource: '',
  utmCampaign: '',
  utmContent: '',
  languageCode: 'en',
  preAcceptanceType: 'None'
};

export const initialBookingFlightData = {
  flightInfoId: '',
  requestFlightNumber: '',
  airportCityName: '',
  flightLeg: null,
  requestDepartureDate: '',
  additionalFlightDataRequest: {
    finalAirportCityName: null,
    finalAirportCode: null,
    finalAirportName: null,
    finalAirportCountryName: null
  }
};

export const initPromoRedemptionRequest = {
  promoCode: '',
  promoDiscountAmount: 0
};

export const initAmendRequest = {
  amendBookingFlag: '',
  bookingJourneyReference: '',
  addBookingRequest: {}
};
